/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchGetEmployment} from '../api'

export const useMutationBatchGetEmployment = createReactQueryMutationHook('batchGetEmployment', batchGetEmployment)
